module.exports = __webpack_public_path__ + "img/trash-bin.d9d0dfce.svg";